export default "__VITE_ASSET__CZNu56G4__"